import Slider from './slider';

const options = {
    autoHeight: true,
    grabCursor: true,
    keyboard: true,
    virtualTranslate: true,
    watchSlidesProgress: true,
    watchSlidesVisibility: true,
    effect: 'poolieCarouselEffect',
    navigation: {
        prevEl: '.js-carousel-arrows-previous',
        nextEl: '.js-carousel-arrows-next',
        disabledClass: 'carousel-arrows__arrow--disabled',
    },
    pagination: {
        el: '.js-carousel-pagination',
        type: 'bullets',
        renderBullet: (index, className) => `<span class="${className}"></span>`,
        bulletClass: 'slider-pagination__bullet',
        bulletActiveClass: 'slider-pagination__bullet--active',
        clickable: true,
    },
    breakpoints: {
        // when window width is >= 992px
        991: {
            autoHeight: true,
        },
    },
};

class Carousel extends Slider {
    constructor(...args) {
        super(...args);

        this.carouselSlides = [];

        this.initEventListeners();
        this.swiper.update();
    }

    set slides(slides) {
        this.carouselSlides = Object.values(slides).slice(0, -1);
    }

    get slides() {
        return this.carouselSlides;
    }

    initEventListeners() {
        this.swiper.on('setTranslate', this.handleTranslate.bind(this));
    }

    handleTranslate() {
        this.slides = this.swiper.slides;
        this.slides.forEach((slide) => slide.removeAttribute('style'));
    }
}

const carousel = {
    init() {
        const elements = document.querySelectorAll('.js-carousel');

        if (!elements.length) return;

        elements.forEach((element) => {
            const {renderCustom} = element.dataset;

            if (renderCustom === '1') {
                options.pagination.bulletClass = 'pagination__item';
                options.pagination.bulletActiveClass = 'active';
                options.pagination.renderBullet = (index, className) => `<li class="${className}">
                                    <a href="#${index}" class="pagination__link">${index + 1}</a>
                                </li>`;
            } else {
                options.pagination.bulletClass = 'slider-pagination__bullet';
                options.pagination.bulletActiveClass = 'slider-pagination__bullet--active';
                options.pagination.renderBullet = (index, className) => `<span class="${className}"></span>`;
            }

            const {renderTimeline} = element.dataset;

            const [...yearsElements] = element.querySelectorAll('[data-year]');
            const years = yearsElements.map(
                (item) => item.dataset.year,
            );

            if (renderTimeline === '1') {
                options.pagination.bulletClass = 'timeline__bullet';
                options.pagination.bulletActiveClass = 'timeline__bullet--filled';
                options.pagination.renderBullet = (index, className) => `
                    <li class="${className}">
                        <span class="timeline__label">${years[index]}</span>
                    </li>`;
            }

            this.slider = new Carousel(element, options);
        });
    },
};

export default carousel;
